import Link from 'next/link'
import { Card, CardBody } from 'reactstrap'
import BreadcrumbBar from '~/components/shared/BreadcrumbBar'

function LoginHelp () {
  const breadcrumbs = [
    { name: 'Login Help', href: '/login-help' }
  ]

  return (
    <>
      <BreadcrumbBar breadcrumbs={breadcrumbs} />

      <h2 className='pb-2'>Login Help</h2>

      <Card>
        <CardBody>
          <h2>Registration and Password</h2>
          <p>To sign up for a mySCPHealth portal / mySCP app account or to change your password please follow the instructions on the link below.</p>
          <ul>
            <li><Link href='/login-help/provider-access'><a>Provider Access (Register/Reset Password)</a></Link></li>
            <li><Link href='/login-help/client-access'><a>Client Access (Register/Reset Password)</a></Link></li>
            <li><Link href='/'><a>Already Registered? Sign In Here</a></Link></li>
          </ul>
          <hr />
          <h2>Multifactor Authentication</h2>
          <p>
            Multi-factor Authentication is a way of confirming a user’s identity by verifying that the user has two or more pieces of information.
            This is usually accomplished by verifying something the user knows (such as a password) and something they have in their possession (such as a mobile device).
          </p>
          <ul>
            <li><Link href='/login-help/mfa-setup'><a>Setup</a></Link></li>
            <li><Link href='/login-help/okta-verify'><a>Okta Verify</a></Link></li>
            <li><Link href='/login-help/sms-auth'><a>SMS Authentication</a></Link></li>
            <li><Link href='/login-help/voice-call-auth'><a>Voice Call Authentication</a></Link></li>
            <li><Link href='/login-help/change-auth-methods'><a>How To Change Authentication Methods</a></Link></li>
          </ul>
          <hr />
          <h2>Using Multifactor Authentication</h2>
          <p>
            There are multiple ways for you to login to your account using either Okta, SMS Authentication and/or Voice Call Authentication.
            See below to learn more about how each method of verification works.
          </p>
          <ul>
            <li><Link href='/login-help/using-mfa-basics'><a>Basics</a></Link></li>
            <li><Link href='/login-help/using-okta'><a>Using Okta</a></Link></li>
            <li><Link href='/login-help/using-sms-auth'><a>Using SMS Authentication</a></Link></li>
            <li><Link href='/login-help/using-voice-auth'><a>Using Voice Call Authentication</a></Link></li>
          </ul>
          <hr />
          <h2>mySCP Product Access</h2>
          <p>
          Typically, you will be required to enter an organization name to access any of the mySCP mobile applications.
          You should have received this in your onboarding information packet email. You will only have to enter this once when prompted after your first login.
          For Example, entering SCP in this field is the default, when prompted after first login.
          </p>
          <hr />
        </CardBody>
      </Card>
    </>
  )
}

LoginHelp.publicAccess = true

LoginHelp.getInitialProps = () => ({
  title: 'Login Help'
})

export default LoginHelp
